export const designationsOptions = [
  { value: "P.Eng.", label: "P.Eng." },
  { value: "P.E.", label: "P.E." },
  { value: "E.I.T.", label: "E.I.T." },
  { value: "P.Geo", label: "P.Geo" },
  { value: "Other", label: "Other" },
];
